import getCookie from "./helpers/getCookie";
import setCookie, {setCookieUnixTimestamp} from "./helpers/setCookie";

async function inpostPayBinding() {
  try {
    let data = new FormData();

    let basketBindingApiKey = getCookie("basket_binding_api_key");
    if (basketBindingApiKey) {
      data.append("basket_binding_api_key", basketBindingApiKey);
    }

    const response = await fetch(`/?wc-ajax=inpost_pay_bind`, {
      method: "POST",
      credentials: "same-origin",
      body: data
    });

    if (!response.ok) {
      console.warn('[InPostPay] Bind failed (expected if no basket_binding_api_key):', response.status);
      return;
    }

    try {
      const responseData = await response.json();
      if (responseData.success && responseData.data && responseData.data.basket_binding_api_key) {
        IPPWidgetOptions.basketBindingApiKey = responseData.data.basket_binding_api_key;
        const existingBasketBindingApiKey = getCookie("basket_binding_api_key");
        if (!existingBasketBindingApiKey) {
          setCookieUnixTimestamp(
            "basket_binding_api_key",
            responseData.data.basket_binding_api_key,
            responseData.data.session_expiration,
          );
        }
      }
    } catch (jsonError) {
      console.warn('[InPostPay] Failed to parse bind response JSON:', jsonError);
    }
  } catch (error) {
    console.warn('[InPostPay] Bind error:', error);
  }
}

export { inpostPayBinding };
